// Modal: registrar un toque (Cara A). NO pide resultado ni próximo paso.
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ProspeccionToqueModal = ({ prospectoId, contactos = [], userId, onClose, onSaved, tipo = "toque", titulo = "Registrar toque" }) => {
  const [canal, setCanal]       = useState("");
  const [contactoId, setContactoId] = useState("");
  const [resumen, setResumen]   = useState("");
  const [fecha, setFecha]       = useState(() => new Date().toISOString().slice(0, 16));
  const [canales, setCanales]   = useState([]);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    axios.get(`${BASE}/buscar_canales.php`)
      .then((r) => { if (Array.isArray(r.data)) setCanales(r.data); })
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (tipo === "toque" && !canal) return toast.error("Elegí un canal");
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("prospecto_id", prospectoId);
      fd.append("tipo", tipo);
      if (canal)      fd.append("canal", canal);
      if (contactoId) fd.append("contacto_id", contactoId);
      if (resumen)    fd.append("resumen", resumen);
      if (fecha)      fd.append("fecha", fecha);
      if (userId)     fd.append("usuario_id", userId);

      const r = await axios.post(`${BASE}/prospectos_interacciones_guardar.php`, fd);
      if (r.data?.success) {
        toast.success(tipo === "respuesta" ? "Respuesta registrada · pasó a En diálogo" : "Toque registrado");
        if (onSaved) onSaved(r.data);
      } else {
        toast.error(r.data?.mensaje || "Error al guardar");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 16px", fontSize: 18, fontWeight: 700, color: "#9f0059" }}>{titulo}</h2>
        <form onSubmit={handleSubmit}>
          {tipo === "toque" && (
            <Field label="Canal *">
              <select style={inp} value={canal} onChange={(e) => setCanal(e.target.value)} autoFocus>
                <option value="">Elegir…</option>
                {canales.map((c) => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
              </select>
            </Field>
          )}
          {tipo === "respuesta" && (
            <Field label="Canal de la respuesta (opcional)">
              <select style={inp} value={canal} onChange={(e) => setCanal(e.target.value)}>
                <option value="">—</option>
                {canales.map((c) => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
              </select>
            </Field>
          )}
          {contactos.length > 0 && (
            <Field label="Contacto (opcional)">
              <select style={inp} value={contactoId} onChange={(e) => setContactoId(e.target.value)}>
                <option value="">—</option>
                {contactos.map((c) => <option key={c.id} value={c.id}>{c.nombre}{c.cargo ? ` · ${c.cargo}` : ""}</option>)}
              </select>
            </Field>
          )}
          <Field label="Nota (opcional)">
            <textarea style={{ ...inp, minHeight: 60, fontFamily: "inherit", resize: "vertical" }}
              value={resumen} onChange={(e) => setResumen(e.target.value)}
              placeholder={tipo === "respuesta" ? "Qué dijeron…" : "Qué les mandaste…"} />
          </Field>
          <Field label="Fecha">
            <input style={inp} type="datetime-local" value={fecha} onChange={(e) => setFecha(e.target.value)} />
          </Field>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
            <button type="button" onClick={onClose} style={btnSecondary} disabled={submitting}>Cancelar</button>
            <button type="submit" style={btnPrimary} disabled={submitting}>
              {submitting ? "Guardando…" : "Registrar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 };
const modal   = { background: "#fff", borderRadius: 14, padding: 24, maxWidth: 480, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" };
const inp     = { width: "100%", padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, color: "#222", background: "#fafafa", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
const btnPrimary   = { padding: "9px 22px", background: "#9f0059", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" };
const btnSecondary = { padding: "9px 22px", background: "#fff", color: "#666", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" };
const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>{label}</label>
    {children}
  </div>
);

export default ProspeccionToqueModal;
